import { Template } from './Types';


export const templates: Template[] = [
  {
    "id": "1",
    "title": "Modern ERP Template",
    "description": "A comprehensive and customizable ERP template designed for managing business operations, employees, and resources in a seamless and efficient way.",
    "price": 79,
    "image": "https://storage.ninestarunited.com/ERP/ERP.png",
    "category": "technology",
    "features": [
      "Responsive Design",
      "Employee Management System",
      "Inventory Tracking",
      "CRM Integration",
      "Data Analytics Dashboard",
      "Real-time Uptime Analytics",
      "Employee Login and Profile Management",
      "Customizable API Integration"
    ],
    "pages": [
      "Landing Page",
      "Login Page",
      "Register Page",
      "Contact Page",
      "Pricing Page",
      "Careers Page",
      "API Pricing Page",
      "Dashboard",
      "Faqs Page",
      "Employee Login",
      "Tickets Page",
      "Uptime Analytics Page",
      "Users Profile Page",
      "And more"
    ],
    "previewImages": [
      "https://storage.ninestarunited.com/ERP/HERO.png",
      "https://storage.ninestarunited.com/ERP/MODULES.png",
      "https://storage.ninestarunited.com/ERP/PRICING.png",
      "https://storage.ninestarunited.com/ERP/PRICING.png",
      "https://storage.ninestarunited.com/ERP/api.png",
      "https://storage.ninestarunited.com/ERP/api2.png",
      "https://storage.ninestarunited.com/ERP/careers.png",
      "https://storage.ninestarunited.com/ERP/dash.png",
      "https://storage.ninestarunited.com/ERP/list.png",
      "https://storage.ninestarunited.com/ERP/support.png",
      "https://storage.ninestarunited.com/ERP/welcome.png"
    ],
    "demoUrl": "https://erp.pixelcraft.ninestarunited.com",
    "marketplace": "TemplateMonster"
  },
  {
    "id": "2",
    "title": "AI Background Removal App",
    "description": "A powerful and intuitive template for an AI-based background removal app, featuring advanced tools for image enhancement and transformation.",
    "price": 79,
    "image": "https://storage.ninestarunited.com/AiImage/Screenshot%202025-01-23%20090337.png",
    "category": "technology",
    "features": [
      "Responsive Design",
      "AI-Powered Background Removal",
      "Image Enhancement Tools",
      "Text to Image Generator",
      "Sketch to Image Generator",
      "Reimagine Images",
      "Replace Backgrounds",
      "Generate Image with AI",
      "User Dashboard Integration",
      "Customizable API Integration"
    ],
    "pages": [
      "Landing Page",
      "Dashboard",
      "Contact Page",
      "Enhance Image Page",
      "Generate Image with AI Page",
      "Reimagine Images Page",
      "Remove Background Page",
      "Sign In Page",
      "Sign Up Page",
      "Replace Background Page",
      "Text to Image Page",
      "Sketch to Image Page"
    ],
    "previewImages": [
      "https://storage.ninestarunited.com/AiImage/Screenshot%202025-01-23%20090453.png",
      "https://storage.ninestarunited.com/AiImage/Screenshot%202025-01-23%20090606.png",
      "https://storage.ninestarunited.com/AiImage/dash.png",
      "https://storage.ninestarunited.com/AiImage/hero.png"
    ],
    "demoUrl": "https://ai-background-removal.pixelcraft.ninestarunited.com",
    "marketplace": "ThemeForest"
  }
,  
{
  "id": "3",
  "title": "Lighting & Events Services Template",
  "description": "A professional template designed for companies providing lighting, event structure services, and tools, with a clean and functional layout.",
  "price": 89,
  "image": "https://storage.ninestarunited.com/Sound/hero.png",
  "category": "business",
  "features": [
    "Responsive Design",
    "SEO Optimized",
    "Service Sections",
    "Portfolio Showcase",
    "Team Page",
    "Client Testimonials",
    "Blog Integration",
    "Contact Form",
    "Career Opportunities"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "Faqs Page",
    "Blog Page",
    "Careers Page",
    "Blog Details Page",
    "Lighting Service Page",
    "Portfolio Page",
    "Projection Service Page",
    "Sound Service Page",
    "Structures Service Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Sound/about.png",
    "https://storage.ninestarunited.com/Sound/blog.png",
    "https://storage.ninestarunited.com/Sound/blog2.png",
    "https://storage.ninestarunited.com/Sound/careers.png",
    "https://storage.ninestarunited.com/Sound/contact.png",
    "https://storage.ninestarunited.com/Sound/faqs.png",
    "https://storage.ninestarunited.com/Sound/footrt.png",
    "https://storage.ninestarunited.com/Sound/lighting.png",
    "https://storage.ninestarunited.com/Sound/port.png",

  ],
  "demoUrl": "https://events.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
}
,
{
  "id": "4",
  "title": "Songwriter Songs Catalog Template",
  "description": "A sleek and professional template designed for songwriters to showcase and manage their song catalogs with an integrated music player.",
  "price": 49,
  "image": "https://storage.ninestarunited.com/SongCatalog/catalog.png",
  "category": "music",
  "features": [
    "Song Catalog Management",
    "Integrated Music Player",
    "Responsive Design",
    "SEO Optimized",
    "Easy-to-Navigate Layout",
    "Contact Form",
    "License Information Section"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "Songs Catalog Page",
    "Music Player Page",
    "Faqs Page",
    "License Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/SongCatalog/fawqs.png",
    "https://storage.ninestarunited.com/SongCatalog/hero.png",
    "https://storage.ninestarunited.com/SongCatalog/license.png",
    "https://storage.ninestarunited.com/SongCatalog/player.png",
    "https://storage.ninestarunited.com/SongCatalog/process.png"
  ],
  "demoUrl": "https://songcatalog.pixelcraft.ninestarunited.com",
  "marketplace": "ThemeForest"
}
,
{
  "id": "5",
  "title": "BarberShop Website Template",
  "description": "A modern and stylish template designed for barbershops to showcase services, promotions, and manage bookings with ease.",
  "price": 69,
  "image": "https://storage.ninestarunited.com/Barber/Hero.png",
  "category": "barbershop",
  "features": [
    "Booking System",
    "Promotions Section",
    "Pricing Table",
    "Responsive and Mobile-Friendly",
    "SEO Optimized",
    "Gallery Showcase",
    "Service Details"
  ],
  "pages": [
    "Landing Page",
    "About Page",
    "Blog Page",
    "Booking Page",
    "Contact Page",
    "Gallery Page",
    "Pricing Page",
    "Reservation Form",
    "Services Page",
    "Promotion Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Barber/Reserve.png",
    "https://storage.ninestarunited.com/Barber/Screen.png",
    "https://storage.ninestarunited.com/Barber/contact.png",
    "https://storage.ninestarunited.com/Barber/gallery.png",
    "https://storage.ninestarunited.com/Barber/preicing.png",
    "https://storage.ninestarunited.com/Barber/services.png"
  ],
  "demoUrl": "https://barbershop.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
}
,
{
  "id": "6",
  "title": "Night Club Website Template",
  "description": "An electrifying and vibrant template designed for nightclubs to showcase their menu, events, and ambiance while managing reservations with style.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Bar/hero.png",
  "category": "nightlife",
  "features": [
    "Event Promotion",
    "Menu Showcase",
    "Reservation System",
    "Photo Gallery",
    "SEO Optimized",
    "Mobile-Responsive Design",
    "Online Store Integration"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "Bites Page",
    "Careers Page",
    "Cocktails Page",
    "Faqs Page",
    "Gallery Page",
    "Menu Page",
    "Reservation Page",
    "Spirits Page",
    "Store Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Bar/career.png",
    "https://storage.ninestarunited.com/Bar/drinks.png",
    "https://storage.ninestarunited.com/Bar/gallery.png",
    "https://storage.ninestarunited.com/Bar/resere.png",
    "https://storage.ninestarunited.com/Bar/specials.png",
    "https://storage.ninestarunited.com/Bar/store.png"
  ],
  "demoUrl": "https://nightclub.pixelcraft.ninestarunited.com",
  "marketplace": "ThemeForest"
}
,
{
  "id": "7",
  "title": "College Website Template",
  "description": "A comprehensive and professional template for colleges and educational institutions to showcase their programs, campus life, and services.",
  "price": 69,
  "image": "https://storage.ninestarunited.com/college/hero.png",
  "category": "education",
  "features": [
    "Program Listings",
    "Library System",
    "News Integration",
    "Custom 404 Page",
    "Environment-Conscious Section",
    "Responsive and Mobile-Friendly Design",
    "Contact Form",
    "SEO Optimized"
  ],
  "pages": [
    "Landing Page",
    "Book Request Page",
    "Campus Life Page",
    "Careers Page",
    "Books Catalog Page",
    "Contact Page",
    "Environment-Conscious Page",
    "Faqs Page",
    "International Help for Students Page",
    "Library Page",
    "News Page",
    "NotFound (Custom 404) Page",
    "Programs Page",
    "Program Details Page",
    "Research Page",
    "Staff Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/college/about.png",
    "https://storage.ninestarunited.com/college/contact.png",
    "https://storage.ninestarunited.com/college/details.png",
    "https://storage.ninestarunited.com/college/dire.png",
    "https://storage.ninestarunited.com/college/extra.png",
    "https://storage.ninestarunited.com/college/hero.png",
    "https://storage.ninestarunited.com/college/high.png",
    "https://storage.ninestarunited.com/college/libr.png",
    "https://storage.ninestarunited.com/college/news.png",
    "https://storage.ninestarunited.com/college/prog.png",
    "https://storage.ninestarunited.com/college/req.png",
    "https://storage.ninestarunited.com/college/request.png",
    "https://storage.ninestarunited.com/college/resea.png",
    "https://storage.ninestarunited.com/college/resealo.png"
  ],
  "demoUrl": "https://college.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
}
,
{
  "id": "8",
  "title": "Currency Exchange Website Template",
  "description": "A modern and user-friendly template designed for currency exchange services, featuring essential tools and a professional layout.",
  "price": 49,
  "image": "https://storage.ninestarunited.com/currency/hero.png",
  "category": "finance",
  "features": [
    "Currency Calculator",
    "Real-Time Exchange Rates",
    "Dashboard for Users",
    "Responsive and Mobile-Friendly Design",
    "SEO Optimized",
    "Contact Form",
    "FAQ Section"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "Faqs Page",
    "About Page",
    "Calculator Page",
    "Currencies Page",
    "Currency Rate Page",
    "Dashboard"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/currency/about.png",
    "https://storage.ninestarunited.com/currency/awards.png",
    "https://storage.ninestarunited.com/currency/calc.png",
    "https://storage.ninestarunited.com/currency/contact.png",
    "https://storage.ninestarunited.com/currency/currency..png",
    "https://storage.ninestarunited.com/currency/dash.png",
    "https://storage.ninestarunited.com/currency/faqs.png",
    "https://storage.ninestarunited.com/currency/rates.png"
  ],
  "demoUrl": "https://currency.pixelcraft.ninestarunited.com",
  "marketplace": "ThemeForest"
}
,
{
  "id": "9",
  "title": "Restaurant Management Software Template",
  "description": "A comprehensive and modern template for restaurant management systems, packed with features to streamline operations.",
  "price": 89,
  "image": "https://storage.ninestarunited.com/Menu/dashboard.png",
  "category": "software",
  "features": [
    "Category Setup",
    "Interactive Dashboard",
    "Coupon and Discount Management",
    "Employee Management",
    "Loyalty Program Integration",
    "Table and Waiting List Setup",
    "Supplier Management",
    "Event Planning Tools",
    "Payment Processing Integration"
  ],
  "pages": [
    "Category Setup Page",
    "Dashboard",
    "About Page",
    "Company Settings Page",
    "Coupon Creation Page",
    "Developer Page",
    "Discount Page",
    "Employee Page",
    "Employee Review Page",
    "Events Page",
    "Ingredient Page",
    "Loyalty Page",
    "Offers Page",
    "Payment Page",
    "Table Setup Page",
    "Waiting List Setup Page",
    "Tickets Page",
    "Supplier Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Menu/clients.png",
    "https://storage.ninestarunited.com/Menu/campaign.png",
    "https://storage.ninestarunited.com/Menu/custo.png",
    "https://storage.ninestarunited.com/Menu/das.png",
    "https://storage.ninestarunited.com/Menu/hero.png"
  ],
  "demoUrl": "https://restaurant-management.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
}
,
{
  "id": "10",
  "title": "E-commerce Template",
  "description": "A sleek and modern template designed for online stores to provide an optimal shopping experience.",
  "price": 59,
  "image": "https://storage.ninestarunited.com/eccomerce/hero.png",
  "category": "ecommerce",
  "features": [
    "Responsive Design",
    "Optimized for Conversions",
    "Product Filtering",
    "User-Friendly Navigation",
    "Integrated Shopping Cart"
  ],
  "pages": [
    "Landing Page",
    "Cart Page",
    "Checkout Page",
    "Shop Page",
    "Products Page",
    "Product Details Page",
    "Contact Page",
    "About Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/eccomerce/Cart.png",
    "https://storage.ninestarunited.com/eccomerce/aboit.png",
    "https://storage.ninestarunited.com/eccomerce/checkout.png",
    "https://storage.ninestarunited.com/eccomerce/contact.png",
    "https://storage.ninestarunited.com/eccomerce/details.png",
    "https://storage.ninestarunited.com/eccomerce/pay.png",
    "https://storage.ninestarunited.com/eccomerce/sneakers.png"
  ],
  "demoUrl": "eccomerce.pixelcraft.ninestarunited.com",
  "marketplace": "ThemeForest"
}
,
{
  "id": "11",
  "title": "Developer Digital Portfolio Template",
  "description": "A modern and professional template for developers to showcase their skills, projects, and personal journey.",
  "price": 49,
  "image": "https://storage.ninestarunited.com/Portfolio/Edwin.png",
  "category": "portfolio",
  "features": [
    "Portfolio Showcase",
    "Skill Highlights",
    "Project Details",
    "Responsive Design",
    "Personalized Sections"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "About Page",
    "Biography Page",
    "Hobbies Page",
    "Project Page",
    "Project Details Page",
    "Technology Page",
    "Tech Timeline"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Portfolio/details.png",
    "https://storage.ninestarunited.com/Portfolio/edwin2.png",
    "https://storage.ninestarunited.com/Portfolio/port.png",
    "https://storage.ninestarunited.com/Portfolio/proyec.png",
    "https://storage.ninestarunited.com/Portfolio/tech.png"
  ],
  "demoUrl": "https://edwinthen.portafolio.ninestarunited.com",
  "marketplace": "TemplateMonster"
}
,
{
  "id": "12",
  "title": "Graphic Design Agency Website Template",
  "description": "A comprehensive and visually appealing template for graphic design agencies to showcase their services, portfolio, and expertise.",
  "price": 69,
  "image": "https://storage.ninestarunited.com/Graphics/hero.png",
  "category": "business",
  "features": [
    "Service Details Pages",
    "Portfolio Showcase",
    "Get a Quote Form",
    "Customizable Pricing Page",
    "Responsive and Modern Design"
  ],
  "pages": [
    "Landing Page",
    "About Page",
    "Blog Page",
    "Branding Detail Page",
    "Contact Page",
    "Custom Signage Details Page",
    "Digital Design Page",
    "Event Branding Page",
    "FAQs",
    "Get a Quote Page",
    "Large Format Printing Page",
    "Portfolio Page",
    "Pricing Page",
    "Print Design Page",
    "Promotional Products Page",
    "Serigraphy Page",
    "Services Page",
    "Site Map Page",
    "Vehicle Wrapping Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Graphics/Blog.png",
    "https://storage.ninestarunited.com/Graphics/FQs.png",
    "https://storage.ninestarunited.com/Graphics/Screenshot%202025-01-22%20121923.png",
    "https://storage.ninestarunited.com/Graphics/Screenshot%202025-01-22%20122011.png",
    "https://storage.ninestarunited.com/Graphics/about.png",
    "https://storage.ninestarunited.com/Graphics/contact.png",
    "https://storage.ninestarunited.com/Graphics/hero.png",
    "https://storage.ninestarunited.com/Graphics/port.png",
    "https://storage.ninestarunited.com/Graphics/pricing.png",
    "https://storage.ninestarunited.com/Graphics/quote.png",
    "https://storage.ninestarunited.com/Graphics/services.png",
    "https://storage.ninestarunited.com/Graphics/team.png"
  ],
  "demoUrl": "https://graphic-design-template.pixelcraft.ninestarunited.com",
  "marketplace": "ThemeForest"
}
,
{
  "id": "13",
  "title": "Analytics Software Website Template",
  "description": "A professional and modern template designed for analytics software companies to showcase their features and tools.",
  "price": 39,
  "image": "https://storage.ninestarunited.com/Analytics/dash.png",
  "category": "business",
  "features": [
    "Detailed Dashboard Layout",
    "Integration Showcase",
    "Pricing Plans",
    "User Authentication Pages",
    "SEO-Optimized Design"
  ],
  "pages": [
    "Landing Page",
    "About Page",
    "Contact Page",
    "Dashboard",
    "FAQs",
    "Features Page",
    "Integrations Page",
    "Pricing Page",
    "Login Page",
    "Sign Up Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Analytics/about.png",
    "https://storage.ninestarunited.com/Analytics/faqs.png",
    "https://storage.ninestarunited.com/Analytics/fea.png",
    "https://storage.ninestarunited.com/Analytics/hero.png",
    "https://storage.ninestarunited.com/Analytics/pricing.png"
  ],
  "demoUrl": "https://analytics.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
}
,
{
  "id": "14",
  "title": "Hotel Website Template",
  "description": "A comprehensive template designed for hotels to showcase their services, events, and amenities.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/hotel/wed.png",
  "category": "hospitality",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Hotel Room Showcase",
    "Event Halls Details",
    "Digital Store Integration",
    "Menu Display",
    "News and Updates Section"
  ],
  "pages": [
    "Landing Page",
    "Services Page",
    "Restaurant Page",
    "Event Halls Page",
    "Digital Store Page",
    "News Page",
    "Digital Menu Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/hotel/event.png",
    "https://storage.ninestarunited.com/hotel/footer.png",
    "https://storage.ninestarunited.com/hotel/landing.png",
    "https://storage.ninestarunited.com/hotel/reserve.png",
    "https://storage.ninestarunited.com/hotel/rest.png",
    "https://storage.ninestarunited.com/hotel/room.png",
    "https://storage.ninestarunited.com/hotel/rest2.png",
    "https://storage.ninestarunited.com/hotel/servce.png",
    "https://storage.ninestarunited.com/hotel/services.png"
  ],
  "demoUrl": "https://hotel.pixelcraft.ninestarunited.com",
  "marketplace": "ThemeForest"
}
,
{
  "id": "15",
  "title": "Journalist Website Template",
  "description": "A modern and clean template designed for journalists to showcase their news articles, reports, and stories.",
  "price": 69,
  "image": "https://storage.ninestarunited.com/News/hero.png",
  "category": "news",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Article Showcase",
    "Category Listings",
    "Latest News Section",
    "Social Media Integration",
    "Comment System"
  ],
  "pages": [
    "Landing Page",
    "Category Page",
    "About Page",
    "Contact Page",
    "FAQ Page",
    "Latest News Page",
    "Local News Map Page",
    "Article Details Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/News/News5.png",
    "https://storage.ninestarunited.com/News/article2.png",
    "https://storage.ninestarunited.com/News/articles.png",
    "https://storage.ninestarunited.com/News/cat.png",
    "https://storage.ninestarunited.com/News/hero.png",
    "https://storage.ninestarunited.com/News/multi.png",
    "https://storage.ninestarunited.com/News/news.png",
    "https://storage.ninestarunited.com/News/us.png"
  ],
  "demoUrl": "https://journalism.pixelcraft.ninestarunited.com",
  "marketplace": "ThemeForest"
}
,
{
  "id": "17",
  "title": "Architecture Website Template",
  "description": "A modern and clean template designed for architecture firms to showcase their projects, services, and portfolio.",
  "price": 69,
  "image": "https://storage.ninestarunited.com/Juve/hero.png",
  "category": "architecture",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Project Portfolio Showcase",
    "Client Testimonials",
    "Service Overview",
    "Contact Form",
    "Team Section"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "About Page",
    "Portfolio Page",
    "Certifications Page",
    "Careers Page",
    "FAQs Page",
    "Privacy Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Juve/about.png",
    "https://storage.ninestarunited.com/Juve/catalog.png",
    "https://storage.ninestarunited.com/Juve/cert.png",
    "https://storage.ninestarunited.com/Juve/cookie..png",
    "https://storage.ninestarunited.com/Juve/faqs.png",
    "https://storage.ninestarunited.com/Juve/hero.png",
    "https://storage.ninestarunited.com/Juve/service.png",
    "https://storage.ninestarunited.com/Juve/us.png"
  ],
  "demoUrl": "https://architecture.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
},
{
  "id": "18",
  "title": "Immigration Lawyer Website Template",
  "description": "A professional and informative template designed for immigration lawyers to showcase their services, success stories, and legal expertise.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Law/hero.png",
  "category": "law",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Service Overview",
    "Client Testimonials",
    "Blog Integration",
    "Contact Form",
    "Success Stories Showcase"
  ],
  "pages": [
    "Landing Page",
    "About Page",
    "Contact Page",
    "Blog Page",
    "Blog Details Page",
    "FAQ Page",
    "Custom 404 Page",
    "Reservation Stepper Page",
    "Services Page",
    "Service Details Page",
    "Success Cases Page",
    "Terms Page",
    "Privacy Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Law/about.png",
    "https://storage.ninestarunited.com/Law/blog.png",
    "https://storage.ninestarunited.com/Law/cases.png",
    "https://storage.ninestarunited.com/Law/contact.png",
    "https://storage.ninestarunited.com/Law/details.png",
    "https://storage.ninestarunited.com/Law/faqs.png",
    "https://storage.ninestarunited.com/Law/hero.png",
    "https://storage.ninestarunited.com/Law/ramifica.png",
    "https://storage.ninestarunited.com/Law/reserve.png",
    "https://storage.ninestarunited.com/Law/service.png"
  ],
  "demoUrl": "https://law.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
},
{
  "id": "19",
  "title": "Technology Website Template",
  "description": "A modern and clean template designed for technology companies to showcase their products, services, and expertise.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Military/hero.png",
  "category": "technology",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Service Overview",
    "Product Showcase",
    "Client Testimonials",
    "Contact Form",
    "Global Reach Display"
  ],
  "pages": [
    "Landing Page",
    "About Page",
    "Case Studies Page",
    "Certifications Page",
    "Clients Page",
    "Contact Page",
    "Global Reach Page",
    "Legal Notice Page",
    "Custom 404 Page",
    "Privacy Page",
    "Products Page",
    "Product Details Page",
    "Security Page",
    "Services Page",
    "Technology Page",
    "Terms Page",
    "Why Us Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Military/hero.png",
    "https://storage.ninestarunited.com/Military/Tech.png",
    "https://storage.ninestarunited.com/Military/case.png",
    "https://storage.ninestarunited.com/Military/cert.png",
    "https://storage.ninestarunited.com/Military/compliance.png",
    "https://storage.ninestarunited.com/Military/contact.png",
    "https://storage.ninestarunited.com/Military/global.png",
    "https://storage.ninestarunited.com/Military/inno.png",
    "https://storage.ninestarunited.com/Military/prod.png",
    "https://storage.ninestarunited.com/Military/services.png",
  ],
  "demoUrl": "https://technology.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
},
{
  "id": "20",
  "title": "Music Publisher Website Template",
  "description": "A professional template designed for music publishers to showcase their catalog, services, and licensing opportunities.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Mpublisher/hero.png",
  "category": "music",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Music Catalog Showcase",
    "Copyright Information",
    "Royalties Management",
    "Sync Licensing Opportunities",
    "Client Testimonials",
    "Contact Form"
  ],
  "pages": [
    "Landing Page",
    "FAQs Page",
    "Contact Page",
    "Catalog Page",
    "Copyright Page",
    "Music Publishing Page",
    "Network Page",
    "Custom 404 Page",
    "PROS Page",
    "Royalties Page",
    "Sync Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Mpublisher/Faqs.png",
    "https://storage.ninestarunited.com/Mpublisher/catalog.png",
    "https://storage.ninestarunited.com/Mpublisher/copyright.png",
    "https://storage.ninestarunited.com/Mpublisher/hero.png",
    "https://storage.ninestarunited.com/Mpublisher/network.png",
    "https://storage.ninestarunited.com/Mpublisher/pros.png",
    "https://storage.ninestarunited.com/Mpublisher/pros2.png",
    "https://storage.ninestarunited.com/Mpublisher/publig.png",
    "https://storage.ninestarunited.com/Mpublisher/royalties.png",
    "https://storage.ninestarunited.com/Mpublisher/services.png",
    "https://storage.ninestarunited.com/Mpublisher/sinc.png",
    "https://storage.ninestarunited.com/Mpublisher/tech.png"
  ],
  "demoUrl": "https://music-publisher.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
},

{
  "id": "21",
  "title": "Music School Website Template",
  "description": "A comprehensive template designed for music schools to showcase their classes, events, and instructors.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/MusicSchool/hero.png",
  "category": "music",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Class Showcase",
    "Event Details",
    "Instructor Profiles",
    "Student Information",
    "Contact Form"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "FAQs Page",
    "Category Page",
    "Events Page",
    "Event Details Page",
    "Guitar Classes Page",
    "History Page",
    "404 Custom Page",
    "Piano Classes Page",
    "Piano Courses Page",
    "Privacy Page",
    "Terms Page",
    "Students Page",
    "Teachers Page",
    "Vocal Technique Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/MusicSchool/School.png",
    "https://storage.ninestarunited.com/MusicSchool/Teachers.png",
    "https://storage.ninestarunited.com/MusicSchool/about.png",
    "https://storage.ninestarunited.com/MusicSchool/contact.png",
    "https://storage.ninestarunited.com/MusicSchool/events.png",
    "https://storage.ninestarunited.com/MusicSchool/guitar.png",
    "https://storage.ninestarunited.com/MusicSchool/hero.png",
    "https://storage.ninestarunited.com/MusicSchool/history.png",
    "https://storage.ninestarunited.com/MusicSchool/piano.png",
    "https://storage.ninestarunited.com/MusicSchool/student.png",
    "https://storage.ninestarunited.com/MusicSchool/upcoming.png",
    "https://storage.ninestarunited.com/MusicSchool/vocal.png"
  ],
  "demoUrl": "https://music-school.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
},
{
  "id": "22",
  "title": "Pawnshop Website Template",
  "description": "A professional template designed for pawnshops to showcase their products, services, and policies.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Pawn/hero.png",
  "category": "business",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Product Showcase",
    "Service Overview",
    "Contact Form",
    "Policies Display",
    "Client Testimonials"
  ],
  "pages": [
    "Landing Page",
    "About Page",
    "Blog Page",
    "Blog Details Page",
    "Contact Page",
    "FAQs Page",
    "Policies Page",
    "Products Page",
    "Product Details Page",
    "Services Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Pawn/Prod.png",
    "https://storage.ninestarunited.com/Pawn/about.png",
    "https://storage.ninestarunited.com/Pawn/blog.png",
    "https://storage.ninestarunited.com/Pawn/compra.png",
    "https://storage.ninestarunited.com/Pawn/contact.png",
    "https://storage.ninestarunited.com/Pawn/details.png",
    "https://storage.ninestarunited.com/Pawn/faqs.png",
    "https://storage.ninestarunited.com/Pawn/hero.png",
    "https://storage.ninestarunited.com/Pawn/services.png"
  ],
  "demoUrl": "https://pawnshop.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
},

{
  "id": "23",
  "title": "Real Estate Website Template",
  "description": "A modern template designed for real estate agencies to showcase properties, services, and manage clients.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Real%20Estate/dashboard.png",
  "category": "real estate",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Property Listings",
    "Property Details",
    "Service Overview",
    "Contact Form",
    "User Dashboard",
    "Client Login/Sign Up"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "FAQs Page",
    "About Page",
    "Blog Page",
    "Blog Details Page",
    "Careers Page",
    "Dashboard Page",
    "Login Page",
    "Sign Up Page",
    "Custom 404 Page",
    "Properties Page",
    "Property Details Page",
    "Services Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Real%20Estate/dashboard.png",
    "https://storage.ninestarunited.com/Real%20Estate/hero.png",
    "https://storage.ninestarunited.com/Real%20Estate/blog.png",
    "https://storage.ninestarunited.com/Real%20Estate/blogdetails.png",
    "https://storage.ninestarunited.com/Real%20Estate/careers.png",
    "https://storage.ninestarunited.com/Real%20Estate/contact.png",
    "https://storage.ninestarunited.com/Real%20Estate/details.png",
    "https://storage.ninestarunited.com/Real%20Estate/hero.png",
    "https://storage.ninestarunited.com/Real%20Estate/login.png",
    "https://storage.ninestarunited.com/Real%20Estate/property.png",
    "https://storage.ninestarunited.com/Real%20Estate/proyectos.png",
    "https://storage.ninestarunited.com/Real%20Estate/services.png",
    "https://storage.ninestarunited.com/Real%20Estate/srvices.png",
    "https://storage.ninestarunited.com/Real%20Estate/us.png"

  ],
  "demoUrl": "https://realestate.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
},
{
  "id": "24",
  "title": "Tech Website Template",
  "description": "A modern and sleek template designed for technology companies to showcase their products, services, and corporate information.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Silver/hero.png",
  "category": "technology",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Service Overview",
    "Product Showcase",
    "Client Testimonials",
    "Contact Form",
    "News Integration",
    "Sustainability Focus"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "FAQs Page",
    "About Page",
    "Careers Page",
    "Custom 404 Page",
    "News Page",
    "Privacy Page",
    "Sitemap Page",
    "Terms Page",
    "Sustainability Page",
    "Report Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Silver/hero.png",
    "https://storage.ninestarunited.com/Silver/careers.png",
    "https://storage.ninestarunited.com/Silver/graphs.png",
    "https://storage.ninestarunited.com/Silver/innova.png",
    "https://storage.ninestarunited.com/Silver/inovva.png",
    "https://storage.ninestarunited.com/Silver/maps.png",
    "https://storage.ninestarunited.com/Silver/reports.png",
    "https://storage.ninestarunited.com/Silver/resumen.png"
  ],
  "demoUrl": "https://https://silverriverenterprises.ninestarunited.com",
  "marketplace": "TemplateMonster"
},
{
  "id": "25",
  "title": "Technology Website",
  "description": "A modern and professional template designed for technology companies and software businesses.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Nine/hero.png",
  "category": "technology",
  "demoUrl": "https://ninestarunited.com",
  "features": [
    "Responsive Design",
    "SEO Optimized",
    "Mobile-First Approach",
    "Advanced Performance",
    "Customizable Components"
  ],
  "pages": [
    "Contact Page",
    "Services Page",
    "Services Details Page",
    "Products Page",
    "Faqs Page",
    "Custom 404 Page",
    "Terms Page",
    "Privacy Page",
    "Projects Page",
    "Projects Details",
    "About Page",
    "Sales Contact Page",
    "Careers Page",
    "Reservations Page",
    "Review Page",
    "Tickets Page",
    "Login Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Nine/hero.png",
    "https://storage.ninestarunited.com/Nine/contact.png",
    "https://storage.ninestarunited.com/Nine/details.png",
    "https://storage.ninestarunited.com/Nine/faqs.png",
    "https://storage.ninestarunited.com/Nine/prod.png",
    "https://storage.ninestarunited.com/Nine/services.png",
    "https://storage.ninestarunited.com/Nine/soft.png"
  ],
  "marketplace": "TemplateMonster"

},   
{
  "id": "25",
  "title": "Logistics and Freight Transport Template",
  "description": "A professional and efficient template tailored for logistics and freight transport companies.",
  "price": 59,
  "image": "https://storage.ninestarunited.com/Traelo/hero.png",
  "category": "logistics",
  "demoUrl": "https://traelopaq.portafolio.ninestarunited.com",
  "features": [
    "Responsive Design",
    "SEO Optimized",
    "Mobile-First Approach",
    "Advanced Performance",
    "Customizable Components"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "Careers Page",
    "Faqs Page",
    "Services Page",
    "SiteMap Page",
    "Terms and Conditions Page",
    "Rate Calculator Page",
    "Gallery Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Traelo/hero.png",
    "https://storage.ninestarunited.com/Traelo/serv.png"
  ],
  "marketplace": "TemplateMonster"

},
{
  "id": "26",
  "title": "Educational and Training Platform Template",
  "description": "A comprehensive and versatile template designed for educational institutions and training platforms.",
  "price": 59,
  "image": "https://storage.ninestarunited.com/Tevo/hero.png",
  "category": "education",
  "demoUrl": "https://itevo-site.pages.dev",
  "features": [
    "Responsive Design",
    "SEO Optimized",
    "Customizable Dashboard",
    "User Management",
    "Mobile-First Approach",
    "Advanced Performance"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "Terms Page",
    "Privacy Page",
    "Services Page",
    "Course Page",
    "Course Details Page",
    "Custom 404 Page",
    "Branch Page",
    "Careers Page",
    "Dashboard",
    "Create Vacancy Page",
    "Create Course Page",
    "Login Page",
    "Sign Up Page",
    "Create Branch Page",
    "About Page",
    "Faqs Page",
    "Inscription Page",
    "And more"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Tevo/hero.png",
    "https://storage.ninestarunited.com/Tevo/dash.png",
    "https://storage.ninestarunited.com/Tevo/CURSO.png",
    "https://storage.ninestarunited.com/Tevo/PEXEL.png",
    "https://storage.ninestarunited.com/Tevo/Steps.png",
    "https://storage.ninestarunited.com/Tevo/branch.png",
    "https://storage.ninestarunited.com/Tevo/branch.png",
    "https://storage.ninestarunited.com/Tevo/careers.png",
    "https://storage.ninestarunited.com/Tevo/course.png",
    "https://storage.ninestarunited.com/Tevo/dash.png",
    "https://storage.ninestarunited.com/Tevo/details.png",
    "https://storage.ninestarunited.com/Tevo/faqs.png",
    "https://storage.ninestarunited.com/Tevo/hero.png",
    "https://storage.ninestarunited.com/Tevo/login.png",
    "https://storage.ninestarunited.com/Tevo/services.png"
  ],
  "marketplace": "TemplateMonster"

},

{
  "id": "27",
  "title": "Template Marketplace Website",
  "description": "A professional and user-friendly template for showcasing and selling website templates in a marketplace format.",
  "price": 59,
  "image": "https://storage.ninestarunited.com/TempHub/hero.png",
  "category": "marketplace",
  "demoUrl": "https://pixelcraft.ninestarunited.com",
  "features": [
    "Responsive Design",
    "SEO Optimized",
    "User Reviews",
    "Advanced Search Filters",
    "Secure Payment Integration",
    "Dynamic Content Management"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "Template Support Page",
    "Template Documentation Page",
    "Templates Page",
    "About Page",
    "Terms Page",
    "Privacy Page",
    "Template Details Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/TempHub/hero.png",
    "https://storage.ninestarunited.com/TempHub/conta.png",
    "https://storage.ninestarunited.com/TempHub/docs.png",
    "https://storage.ninestarunited.com/TempHub/privacy.png",
    "https://storage.ninestarunited.com/TempHub/prod.png"
  ],
  "marketplace": "TemplateMonster"

},

{
  "id": "28",
  "title": "Music Recording and Singing Studio Template",
  "description": "A modern and versatile template designed for music recording studios and singing teaching services, offering a range of features for showcasing services and engaging with clients.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Studio/hero.png",
  "category": "music",
  "demoUrl": "https://studio.pixelcraft.ninestarunited.com",
  "features": [
    "Responsive Design",
    "SEO Optimized",
    "Online Reservation System",
    "E-commerce Store Integration",
    "Dynamic Portfolio Showcase",
    "Blog for Content Marketing",
    "Audio and Video Support"
  ],
  "pages": [
    "Landing Page",
    "Music Analysis Service Page",
    "Blog Page",
    "Classes Page (Singing)",
    "Faqs Page",
    "Mastering Service Page",
    "Mixing Service Page",
    "Portfolio Page",
    "Music Producing Service Page",
    "Recording Service Page",
    "Reservation Page",
    "Video Production Page",
    "Store Page",
    "Contact Page",
    "Custom 404 Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Studio/hero.png",
    "https://storage.ninestarunited.com/Studio/about.png",
    "https://storage.ninestarunited.com/Studio/faqs.png",
    "https://storage.ninestarunited.com/Studio/port.png",
    "https://storage.ninestarunited.com/Studio/recording.png",
    "https://storage.ninestarunited.com/Studio/store.png",
    "https://storage.ninestarunited.com/Studio/studo.png"
  ],
  "marketplace": "TemplateMonster"

},

{
  "id": "29",
  "title": "E-commerce Website Template",
  "description": "A fully-featured and customizable e-commerce template designed for modern online stores, with all the essential pages to manage products, orders, and customer accounts.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Store/Dash.png",
  "category": "ecommerce",
  "demoUrl": "https://eccomerce-template.pixelcraft.ninestarunited.com",
  "features": [
    "Responsive Design",
    "SEO Optimized",
    "Advanced Cart System",
    "Product Filters and Sorting",
    "Order Management",
    "User Dashboard Integration",
    "Secure Payment Gateway Integration"
  ],
  "pages": [
    "Landing Page",
    "Category Page",
    "About Page",
    "Products Page",
    "Faqs Page",
    "Login Page",
    "Register Page",
    "Password Reset Page",
    "Review Page",
    "Product Details Page",
    "Privacy Policy",
    "Terms",
    "Contact Page",
    "Dashboard",
    "Orders Page",
    "Wish List Page",
    "Returns Request Page",
    "Bug Report Page",
    "Payment Stepper",
    "Account and User Details Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Store/Dash.png",
    "https://storage.ninestarunited.com/Store/add.png",
    "https://storage.ninestarunited.com/Store/bug.png",
    "https://storage.ninestarunited.com/Store/cart.png",
    "https://storage.ninestarunited.com/Store/cat.png",
    "https://storage.ninestarunited.com/Store/devolu.png",
    "https://storage.ninestarunited.com/Store/order.png",
    "https://storage.ninestarunited.com/Store/orstatus.png",
    "https://storage.ninestarunited.com/Store/pag.png",
    "https://storage.ninestarunited.com/Store/pay.png",
    "https://storage.ninestarunited.com/Store/profile.png",
    "https://storage.ninestarunited.com/Store/track.png",
    "https://storage.ninestarunited.com/Store/wisg.png",
    "https://storage.ninestarunited.com/Store/wish.png"
  ],
  "marketplace": "TemplateMonster"
},
{
  "id": "30",
  "title": "Music  Website Template",
  "description": "A professional template designed for music artistst to showcase their catalog, services, and licensing opportunities.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Ecomusic/hero.png",
  "category": "music",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Music Catalog Showcase",
    "Copyright Information",
    "Royalties Management",
    "Sync Licensing Opportunities",
    "Client Testimonials",
    "Contact Form"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "FAQs Page",
    "Reviews Page",
    "News Page",
    "Music Player Page",
    "Album Releases Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Ecomusic/hero.png",
    "https://storage.ninestarunited.com/Ecomusic/album.png",
    "https://storage.ninestarunited.com/Ecomusic/compa.png",
    "https://storage.ninestarunited.com/Ecomusic/details.png",
    "https://storage.ninestarunited.com/Ecomusic/music.png",
    "https://storage.ninestarunited.com/Ecomusic/releases.png",
    "https://storage.ninestarunited.com/Ecomusic/service.png"
  ],
  "demoUrl": "https://ecomusic.ninestarunited.com",
  "marketplace": "TemplateMonster"
},

{
  "id": "31",
  "title": "Auto Parts Website Template",
  "description": "A professional template designed for auto parts stores to showcase their catalog, services, and sales opportunities.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Parts/hero.png",
  "category": "automotive",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Auto Parts Catalog Showcase",
    "Secure Checkout Integration",
    "Inventory Management",
    "Special Offers and Discounts",
    "Customer Reviews",
    "Contact Form"
  ],
  "pages": [
    "Landing Page",
    "Contact Page",
    "FAQs Page",
    "Reviews Page",
    "Product Details Page",
    "Shopping Cart Page",
    "Checkout Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Parts/hero.png",
    "https://storage.ninestarunited.com/Parts/DASHBOARD2.png",
    "https://storage.ninestarunited.com/Parts/DASHBOARD3.png",
    "https://storage.ninestarunited.com/Parts/Screenshot%202025-02-02%20090846.png",
    "https://storage.ninestarunited.com/Parts/Screenshot%202025-02-02%20091010.png",
    "https://storage.ninestarunited.com/Parts/Screenshot%202025-02-02%20092907.png",
    "https://storage.ninestarunited.com/Parts/about.png",
    "https://storage.ninestarunited.com/Parts/gallery.png",
    "https://storage.ninestarunited.com/Parts/products.png",
    "https://storage.ninestarunited.com/Parts/services.png"
  ],
  "demoUrl": "https://autoparts.ninestarunited.com",
  "marketplace": "TemplateMonster"
},
{
  "id": "32",
  "title": "Corporate Transport Website Template",
  "description": "A professional template designed for corporate transport companies to showcase their services, fleet, and customer testimonials.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/Transportation/hero.png",
  "category": "corporate",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Service Offerings Showcase",
    "Online Booking System",
    "Fleet Management",
    "Pricing Plans",
    "Customer Testimonials",
    "Contact Form"
  ],
  "pages": [
    "Landing Page",
    "About Us Page",
    "Services Page",
    "Fleet Page",
    "Pricing Page",
    "Contact Page",
    "FAQs Page",
    "Routes Page",
    "Schedule Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/Transportation/about.png",
    "https://storage.ninestarunited.com/Transportation/drivers.png",
    "https://storage.ninestarunited.com/Transportation/faqs.png",
    "https://storage.ninestarunited.com/Transportation/fleet.png",
    "https://storage.ninestarunited.com/Transportation/horario.png",
    "https://storage.ninestarunited.com/Transportation/reserve.png",
    "https://storage.ninestarunited.com/Transportation/roures.png"
  ],
  "demoUrl": "https://transportation.pixelcraft.ninestarunited.com",
  "marketplace": "TemplateMonster"
},
{
  "id": "33",
  "title": "Wholesale E-commerce Website Template",
  "description": "A professional template designed for wholesale businesses to showcase their products, manage bulk orders, and provide a seamless shopping experience.",
  "price": 79,
  "image": "https://storage.ninestarunited.com/WholeSale/hero.png",
  "category": "ecommerce",
  "features": [
    "Responsive Layout",
    "SEO Optimized",
    "Bulk Ordering System",
    "Product Catalog Management",
    "Secure Checkout",
    "Customer Reviews",
    "Discount & Pricing Tiers",
    "Contact Form"
  ],
  "pages": [
    "Landing Page",
    "Product Catalog Page",
    "Bulk Orders Page",
    "Pricing Page",
    "Customer Reviews Page",
    "Contact Page",
    "FAQs Page"
  ],
  "previewImages": [
    "https://storage.ninestarunited.com/WholeSale/hero.png",
    "https://storage.ninestarunited.com/WholeSale/about.png",
    "https://storage.ninestarunited.com/WholeSale/caalog.png",
    "https://storage.ninestarunited.com/WholeSale/faq.png",
    "https://storage.ninestarunited.com/WholeSale/produ.png",
    "https://storage.ninestarunited.com/WholeSale/shipping.png",
    "https://storage.ninestarunited.com/WholeSale/warehouses.png"
  ],
  "demoUrl": "https://wholesale.ninestarunited.com",
  "marketplace": "TemplateMonster"
}



];
